import { render, staticRenderFns } from "./cabinet-commercial-notice-card-publish-button.vue?vue&type=template&id=6a2d0cc3&"
import script from "./cabinet-commercial-notice-card-publish-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-commercial-notice-card-publish-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2d0cc3')) {
      api.createRecord('6a2d0cc3', component.options)
    } else {
      api.reload('6a2d0cc3', component.options)
    }
    module.hot.accept("./cabinet-commercial-notice-card-publish-button.vue?vue&type=template&id=6a2d0cc3&", function () {
      api.rerender('6a2d0cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/cards/partials/cabinet-commercial-notice-card-publish-button.vue"
export default component.exports